import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type { PagedResponse, UserStatus, UserSummary, UserWithRoles } from '../types'

const BASE = '/management/users'

/** Kullanıcı listesi (opsiyonel arama q; yönetim ölçeği → size=200). */
export async function getUsers(q?: string): Promise<PagedResponse<UserSummary>> {
  const { data } = await apiClient.get<PagedResponse<UserSummary>>(BASE, {
    params: { page: 0, size: 200, q: q && q.trim() ? q.trim() : undefined },
  })
  return data
}

/** Kullanıcılar + atanmış roller (Kullanıcı Yönetimi listesi); `roleId` → yalnız o role sahip olanlar. */
export async function getUsersWithRoles(
  q?: string,
  roleId?: number,
): Promise<PagedResponse<UserWithRoles>> {
  const { data } = await apiClient.get<PagedResponse<UserWithRoles>>(`${BASE}/with-roles`, {
    params: { page: 0, size: 200, q: q && q.trim() ? q.trim() : undefined, roleId },
  })
  return data
}

/** Kullanıcıya atanmış (aktif) rol id'leri. */
export async function getUserRoles(id: number): Promise<number[]> {
  const { data } = await apiClient.get<number[]>(`${BASE}/${id}/roles`)
  return data
}

/** Kullanıcının rol kümesini ayarla (set semantiği). */
export async function setUserRoles(id: number, roleIds: number[]): Promise<void> {
  await apiClient.put(`${BASE}/${id}/roles`, { roleIds })
}

/** Kullanıcının dahil olduğu grupların id'leri (122). */
export async function getUserGroups(id: number): Promise<number[]> {
  const { data } = await apiClient.get<number[]>(`${BASE}/${id}/groups`)
  return data
}

/**
 * Kullanıcıyı Aktif/Pasif yapar. Yanıt, güncellenmiş satırın kendisidir (rollerle birlikte) — çağıran
 * listeyi baştan çekmeden tek satırı tazeleyebilir ve bir sonraki değişim için yeni `modDate`'i alır.
 */
export async function changeUserStatus(id: number, body: UserStatus): Promise<UserWithRoles> {
  const { data } = await apiClient.put<UserWithRoles>(`${BASE}/${id}/status`, body)
  return data
}

/**
 * Kullanıcı listesini (rolleriyle) Excel (.xlsx) olarak indirir.
 *
 * Liste ucuyla aynı filtreler; sunucu **tüm** filtreli kayıtları döndürür (sayfalama yok). İndirme
 * mekaniği ve dosya adı ortak {@link downloadXlsx} yardımcısındadır (boş filtreler gönderilmez; ad
 * sunucunun Content-Disposition'ından okunur).
 */
export async function exportUsers(q?: string, roleId?: number): Promise<void> {
  await downloadXlsx(`${BASE}/export`, { q, roleId }, 'kullanicilar.xlsx')
}
